import { useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PublicIcon from '@mui/icons-material/Public';
import SearchIcon from '@mui/icons-material/Search';
import LogoutIcon from "@mui/icons-material/Logout";
import {
  IconButton,
  MenuList,
  ListItemIcon,
  Typography,
  Menu as MUIMenu,
  MenuItem,
} from "@mui/material";

import { signout } from "redux/auth/authSlice";

import useStyles from "./styles";

const ITEM_HEIGHT = 48;

const Menu = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  return (
    <Fragment>
      <div style={{minWidth: 180, display: 'flex' , flexDirection: 'row', justifyContent:"space-between"}}>
        <IconButton
          classes={{ root: classes.iconButtonRoot }}
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClickMenu}
        >
          <SearchIcon classes={{ root: classes.iconRoot }} />
        </IconButton>
        <IconButton
          classes={{ root: classes.iconButtonRoot }}
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClickMenu}
        >
          <PublicIcon classes={{ root: classes.iconRoot }} />
        </IconButton>
        <IconButton
          classes={{ root: classes.iconButtonRoot }}
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClickMenu}
        >
          <MoreVertIcon classes={{ root: classes.iconRoot }} />
        </IconButton>
      </div>
      <MUIMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem onClick={() => dispatch(signout())}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Logout</Typography>
        </MenuItem>
      </MUIMenu>
    </Fragment>
  );
};

export default Menu;
